import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ModalComponent } from '@web/birdz-angular';
import { UserService } from 'app/services/user.service';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-modal-help-equipping',
  templateUrl: './modal-help-equipping.component.html',
  styleUrls: ['./modal-help-equipping.component.scss'],
  imports: [TranslocoPipe, ModalComponent, AsyncPipe],
})
export class ModalHelpEquippingComponent {
  private userService = inject(UserService);

  isBirdzAdmin$: Observable<boolean>;

  constructor() {
    this.isBirdzAdmin$ = this.userService.user$.pipe(map(() => this.userService.isBirdzAdmin()));
  }
}
